// authConfig.js - MSAL Configuration for Trane SSO
// Configured with Trane Azure AD federation metadata

export const msalConfig = {
  auth: {
    clientId: "32ff004a-94cd-4e4c-8f3a-4c716e000cf3", // Trane App Registration Client ID
    authority: "https://login.microsoftonline.com/abf9983b-ca77-4f20-9633-ca9c5a847041/oauth2/v2.0/authorize", // Trane Tenant ID
    redirectUri: "https://agentassist.tranetechnologies.com/",
    postLogoutRedirectUri: "https://agentassist.tranetechnologies.com/",
    navigateToLoginRequestUrl: true,
    // Note: Client secrets are NOT used in browser apps (Public Client Application)
    // If Azure AD app requires secret, it must be reconfigured as "Public client/native"
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored (localStorage persists across page refreshes)
    storeAuthStateInCookie: false, // Set to true for IE 11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // Error
            console.error(message);
            break;
          case 1: // Warning
            console.warn(message);
            break;
          case 2: // Info
            console.info(message);
            break;
          case 3: // Verbose
            console.debug(message);
            break;
        }
      }
    }
  }
};

// Add scopes for ID token to be used at Microsoft identity platform endpoints
export const loginRequest = {
  scopes: ["User.Read"] // Minimal scope to test SSO
};

// Add the endpoints here for Microsoft Graph API services you'd like to use
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
